import React from 'react';
import OutStandingReportListFunctional from './components/outstanding-report-list-functional';
import './outstanding-report.scss';

const OutStandingReportList = () => {
	return <OutStandingReportListFunctional />;
};

export default OutStandingReportList;
